const table = {
  toggleEmptyResults: function (currentTable) {
    let rowsTotal = currentTable.querySelectorAll(".js-row").length;
    let rowsHidden = currentTable.querySelectorAll(".js-row.hide").length;
    let emptyResult = currentTable.nextElementSibling;

    rowsTotal === rowsHidden ?
      (currentTable.classList.add("hide"), emptyResult.classList.remove("hide")) :
      (currentTable.classList.remove("hide"), emptyResult.classList.add("hide"));
  },

  searchTable: function () {
      let search = document.querySelectorAll(".js-search-table");

      search.forEach((search) => {
        search.addEventListener("keyup", function () {
          let searchValue = this.value.toLowerCase();
          let currentSearch = search.closest('.table__search');
          let currentTable = currentSearch.nextElementSibling;
          while (currentTable && !currentTable.classList.contains('js-table')) {
              currentTable = currentTable.nextElementSibling;
          }
          let rows = currentTable.querySelectorAll(".js-row");
  
          rows.forEach(function (row) {
            let rowText = row.textContent.toLowerCase();
            if (rowText.indexOf(searchValue) === -1) {
              row.classList.add("hide");
              table.toggleEmptyResults(currentTable)
            } else {
              row.classList.remove("hide");
              table.toggleEmptyResults(currentTable)
            }
          });
        });
      })
  },

  sortTable: function (n, currentTable) {
    let rows, switching, i, x, y, shouldSwitch, dir, switchcount = 0;
    switching = true;
    dir = "asc";

    while (switching) {
      switching = false;
      rows = currentTable.rows;
      for (i = 1; i < (rows.length - 1); i++) {

        shouldSwitch = false;
        x = rows[i].getElementsByTagName("TD")[n];
        y = rows[i + 1].getElementsByTagName("TD")[n];
        if (dir == "asc") {
          if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
            shouldSwitch = true;
            break;
          }
        } else if (dir == "desc") {
          if(x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
            shouldSwitch = true;
            break
          }
        }
      }
      if (shouldSwitch) {
        rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
        switching = true;
        switchcount++;
      } else {
        if (switchcount == 0 && dir == "asc") {
          dir = "desc";
          switching = true;
        }
      }
    }
  },

  initSort: function() {
    const headingsAll = document.querySelectorAll('.js-table-head');
    headingsAll.forEach((headingsCurrent) => {
      
      const headings = headingsCurrent.querySelectorAll('button');
      const headingTriggerCount = headings.length;

      for (let i = 1; i <= headingTriggerCount; i++) {
        const heading = headingsCurrent.querySelector(`.js-table-heading_${i}`);
        heading.addEventListener("click", function () {
          let currentTable;
          if(heading.closest('.sort-container')) {
            currentTable = heading.closest('.sort-container').nextElementSibling
          }else {
            currentTable = heading.closest('.js-table-head').closest('.js-table')
          }
          headings.forEach(item => {
            if(item !== this) {
                item.classList.remove("active")
            }
          })
          this.classList.toggle("active")
          table.sortTable(i - 1, currentTable)
        })
      }
    })
  },
}
table.searchTable();
table.initSort();
